






























































































import { Vue, Component, Prop, Watch } from "vue-property-decorator";
import { trim } from "../../../../util";
import Api from "../../../../api/index";
import request from "../../../../api/request";
import { getCookie, getStorage } from "@szgc/plt-core-v2";
import { Loading } from "element-ui";
import { SzgcFormGetor } from "@/index";

@Component({
  name: "SendFormPageMobile",
  components: {
    SzgcFormGetor
  }
})
export default class SendFormPageMobile extends Vue {
  @Prop({
    type: Object,
    default() {
      return null;
    }
  })
  private dataAll!: any;

  @Prop({
    type: Boolean,
    default: false
  })
  private status!: any;

  @Prop({
    type: Object,
    default() {
      return {};
    }
  })
  private runTimeFields!: any;

  private isEdit: boolean = false;
  private editBtn: any = {
    enable: false
  };
  private flowData: any = null;
  private formConfig: any = {
    auths: "",
    formRenderData: "",
    results: "",
    pacId: "",
    businessId: "",
    businessName: "",
    reqToken: ""
  };
  private buttonList: any = [];
  private nowBtn: any = null;
  private modalShow: boolean = false;
  private form: any = {
    fileNames: "",
    attIds: [],
    idea: ""
  };
  private rules: any = {};
  private fileUpdLoading: any = null;
  private reqToken: string = "";
  private prefix: string = "";
  private token: any = "";

  @Watch("dataAll", { immediate: true, deep: true })
  private getData(newVal: any) {
    if (newVal) {
      this.prefix = getCookie("plt-api-route") || getStorage("plt-api-route") || "";
      this.token = getCookie("SZGC-SHIRO-TOKEN") || getStorage("SZGC-SHIRO-TOKEN") || "";
      // if (localStorage.getItem('offline') && localStorage.getItem('offline') === "true") {
      // }
      this.flowData = JSON.parse(JSON.stringify(newVal));
      this.reqToken = this.flowData.reqToken;
      this.formConfig = {
        ...this.flowData,
        auths: this.flowData.auths,
        formRenderData: this.flowData.formRender,
        results: this.flowData.fields,
        pacId: this.flowData.pacId,
        businessId: this.flowData.businessId,
        businessName: this.flowData.businessName,
        reqToken: this.reqToken
      };
      this.getFlowData();
    }
  }

  /*处理按钮*/
  async getFlowData() {
    const buttonList: any = [];
    if (this.flowData.actions && this.flowData.actions.length > 0) {
      this.flowData.actions.map((item: any) => {
        buttonList.push(item);
      });
    }
    this.editBtn = this.flowData.edit;
    this.buttonList = buttonList;
  }

  /*点击按钮*/
  async clickBtn(item: any) {
    this.nowBtn = item;
    if (item.needSecondSubmit) {
      //二次提交
      if (item.ifAttEnable) {
        this.rules = {
          fileNames: [{ required: item.ifAttRequire, message: "附件不能为空" }]
        };
      }
      this.modalShow = true;
    } else {
      if (item.btnKey === "edit") {
        //编辑按钮
        this.editSend();
      } else {
        //其它按钮
        this.otherSend();
      }
    }
  }

  /*退出编辑*/
  cancelEdit() {
    this.isEdit = false;
    this.$emit("childEvt", { type: "refresh" });
  }

  /*编辑提交*/
  async editSend() {
    let formBoxData = {};
    const allData = await (this.$refs.sendFormComponent as any).getFormValues();
    if (!allData.valid) {
      this.$message.error(allData.message ? allData.message : "操作失败，有必填项未填!");
      return false;
    }
    formBoxData = allData.data;
    const params = {
      attIds: this.form.attIds === "" ? null : this.form.attIds,
      businessId: this.flowData.businessId,
      ccs: null,
      fields: formBoxData,
      idea: trim(this.form.idea),
      reqToken: this.reqToken
    };
    try {
      const { success, message } = await request({
        url: this.prefix + Api.sendEditFunc(),
        method: "post",
        data: params
      });
      if (!success) {
        this.$message.error(`流程${this.nowBtn.btnName}失败:` + message);
        return false;
      }
      this.isEdit = false;
      this.modalShow = false;
      this.$message.success(`流程${this.nowBtn.btnName}成功`);
      this.$emit("childEvt", { type: "close" });
    } catch (error: any) {
      this.$message.error(`流程${this.nowBtn.btnName}失败:` + error);
    }
  }

  /*其它按钮带表单提交*/
  async otherSend() {
    let formBoxData = {};
    if (this.nowBtn.btnKey === "repeal" || this.nowBtn.btnKey === "terminate") {
      //撤销repeal 终止terminate
      const allData = await (this.$refs.sendFormComponent as any).getFormValues(false);
      formBoxData = allData.data;
    } else {
      const allData = await (this.$refs.sendFormComponent as any).getFormValues();
      if (!allData.valid) {
        this.$message.error(allData.message ? allData.message : "操作失败，有必填项未填!");
        return false;
      }
      formBoxData = allData.data;
    }
    const params = {
      attIds: this.form.attIds === "" ? null : this.form.attIds,
      btnKey: this.nowBtn.btnKey,
      businessId: this.flowData.businessId,
      ccs: null,
      fields: formBoxData,
      idea: trim(this.form.idea),
      reqToken: this.reqToken
    };
    try {
      const { success, message } = await request({
        url: this.prefix + Api.sendActFunc(),
        method: "post",
        data: params
      });
      if (!success) {
        this.$message.error(`流程${this.nowBtn.btnName}失败:` + message);
        return false;
      }
      this.modalShow = false;
      this.$message.success(`流程${this.nowBtn.btnName}成功`);
      this.$emit("childEvt", { type: "close" });
    } catch (error: any) {
      this.$message.error(`流程${this.nowBtn.btnName}失败:` + error);
    }
  }

  /*弹窗确定*/
  async sureEvt() {
    let flag;
    await (this.$refs.sendModalForm as any).validate((valid: any) => {
      flag = valid;
    });
    if (flag) {
      if (this.nowBtn.btnKey === "edit") {
        this.editSend();
      } else {
        this.otherSend();
      }
    }
  }

  /*弹窗关闭*/
  closeModal() {
    this.form = {
      fileNames: "",
      attIds: [],
      idea: ""
    };
  }

  /*附件box点击*/
  showUploadBox() {
    (document.getElementById("secondSendUploadFile") as any).value = "";
    (document.getElementById("secondSendUploadFile") as HTMLDivElement).click();
  }

  /*多文件上传*/
  multiUpload(event: any) {
    let files = event.target.files;
    let formData = new FormData();
    if (files.length === 0) {
      return false;
    }
    for (let i = 0; i < files.length; i++) {
      formData.append("files", files[i]);
    }
    this.fileUpdLoading = Loading.service({
      lock: true,
      fullscreen: true,
      text: "附件上传中..."
    });
    request({
      url: this.prefix + Api.mulUploadFiles,
      method: "post",
      data: formData
    })
      .then((res: any) => {
        if (res.success) {
          let tempIds: any = [],
            tempNames: any = [];
          if (res.data && res.data.length && res.data.length > 0) {
            res.data.map((item: any) => {
              tempIds.push(item.fileId);
              tempNames.push(item.name);
            });
          }
          this.form.fileNames = tempNames.join(",");
          this.form.attIds = tempIds;
          this.$message.success("附件上传成功");
        } else {
          this.form.fileNames = "";
          this.form.attIds = [];
          this.$message.error("附件上传失败");
        }
        this.fileUpdLoading.close();
      })
      .catch((error: any) => {
        this.form.fileNames = "";
        this.form.attIds = [];
        this.fileUpdLoading.close();
        this.$message.error("附件上传失败: " + error);
      });
  }
}
